const serviceBaseUrl = "/api";

const normalizeShowAllClients = (showAllClients) => {
  if (typeof showAllClients === "string") {
    const normalizedValue = showAllClients.trim().toLowerCase();

    if (normalizedValue === "yes" || normalizedValue === "true") {
      return "Yes";
    }

    if (normalizedValue === "no" || normalizedValue === "false") {
      return "No";
    }
  }

  if (typeof showAllClients === "boolean") {
    return showAllClients ? "Yes" : "No";
  }

  return "No";
};

export const SERVICE_URLS = {
  OE_PERIOD_LIST: `${serviceBaseUrl}/OEPeriod`,
  OE_PERIOD_POST: `${serviceBaseUrl}/OEPeriod`,
  OE_PERIOD_PUT: `${serviceBaseUrl}/OEPeriod`,
  OE_PERIOD_PUT_STATUS: `${serviceBaseUrl}/OEPeriod/status`,
  OE_PERIOD_DELETE: `${serviceBaseUrl}/OEPeriod`,
  CARRIER_LIST: `${serviceBaseUrl}/carrier`,
  CARRIER_POST: `${serviceBaseUrl}/carrier`,
  CARRIER_PUT: `${serviceBaseUrl}/carrier`,
  CARRIER_DELETE: `${serviceBaseUrl}/carrier`,
  CARRIER_READINESS_LIST: `${serviceBaseUrl}/carrier/readiness`,
  CARRIER_READINESS_PUT: `${serviceBaseUrl}/carrier/readiness`,
  CARRIER_READINESS_AUDIT: (carrierId) => `${serviceBaseUrl}/carrier/readiness/${carrierId}/audit`,
  CARRIER_TERMINATED_PLANS: `${serviceBaseUrl}/carrier/terminated-plans`,
  CARRIER_TYPE_LIST: `${serviceBaseUrl}/carrier/types`,
  CARRIER_TYPE_POST: `${serviceBaseUrl}/carrier/types`,
  CARRIER_TYPE_DELETE: `${serviceBaseUrl}/carrier/types`,
  IMPORT_LIST: (oePeriodId) =>
    `${serviceBaseUrl}/import?oePeriod=${oePeriodId}`,
  IMPORT_PAGE: (oePeriodId, pageNumber, pageSize, sort) => {
    let url = `${serviceBaseUrl}/import/page?pageNumber=${pageNumber}&pageSize=${pageSize}`;
    if (oePeriodId) url += `&oePeriodId=${oePeriodId}`;
    if (sort && sort.length > 0) {
      sort.forEach((s, index) => {
        url += `&sort[${index}].field=${s.field}&sort[${index}].dir=${s.dir}`;
      });
    }
    return url;
  },
  IMPORT_SUMMARY_LIST: (oePeriodId) =>
    `${serviceBaseUrl}/import/oeperiods/${oePeriodId}/summary`,
  IMPORT_LIST_All: `${serviceBaseUrl}/import`,
  IMPORT_QUEUE: `${serviceBaseUrl}/import`,
  IMPORT_ITEM: (importId) => `${serviceBaseUrl}/import/${importId}`,
  IMPORT_ERRORS: (importId) => `${serviceBaseUrl}/import/${importId}/errors`,
  IMPORT_SUBMIT_ERRORS: (importId) =>
    `${serviceBaseUrl}/import/${importId}/submitErrors`,
  IMPORT_RATES: (importId) => `${serviceBaseUrl}/import/${importId}/rates`,
  IMPORT_FINAL_RATES_LIST: (importId) =>
    `${serviceBaseUrl}/import/${importId}/finalrates`,
  IMPORT_FINAL_RATES_EXPORT: (importId) =>
    `${serviceBaseUrl}/import/${importId}/finalrates/export`,
  IMPORT_PLANMAPPING_LIST: (importId) =>
    `${serviceBaseUrl}/import/${importId}/planmapping`,
  IMPORT_RATEGROUPMAPPING_LIST: (importId) =>
    `${serviceBaseUrl}/import/${importId}/rategroupmapping`,
  IMPORT_PLANGROUPS_LIST: (importId) =>
    `${serviceBaseUrl}/import/${importId}/plangroups`,
  IMPORT_COSTS_LIST: (importId) => `${serviceBaseUrl}/import/${importId}/costs`,
  IMPORT_COSTS_POST: (importId) => `${serviceBaseUrl}/import/${importId}/costs`,
  IMPORT_RETRY_MAPPING_POST: (importId) =>
    `${serviceBaseUrl}/import/${importId}/retrymapping`,
  IMPORT_APPROVE_RATES_POST: (importId) =>
    `${serviceBaseUrl}/import/${importId}/approverate`,
  IMPORT_SUBMIT_RATES_POST: (importId) =>
    `${serviceBaseUrl}/import/${importId}/submitrate`,
  IMPORT_COSTS_DELETE: (importId) =>
    `${serviceBaseUrl}/import/${importId}/costs`,
  IMPORT_STANDARD_RATE_TEMPLATE: `${serviceBaseUrl}/import/standardratetemplate`,

  BENEFIT_PLAN_DETAIL_IMPORT: (oePeriodId, oeWorkflowId) =>
    `${serviceBaseUrl}/benefitplan/detailfile?oePeriodId=${oePeriodId}&oeWorkflowId=${oeWorkflowId}`,
  PLAN_MAPPING_LIST: `${serviceBaseUrl}/benefitplanmapping`,
  PLAN_MAPPING_PAGE: (page, size, sort) => {
    let url = `${serviceBaseUrl}/benefitplanmapping/page?pageNumber=${page}&pageSize=${size}`;
    if (sort && sort.length > 0) {
      sort.forEach((s, index) => {
        url += `&sort[${index}].field=${s.field}&sort[${index}].dir=${s.dir}`;
      });
    }
    return url;
  },
  PLAN_MAPPING_POST: `${serviceBaseUrl}/benefitplanmapping`,
  PLAN_MAPPING_PUT: `${serviceBaseUrl}/benefitplanmapping`,
  PLAN_MAPPING_DELETE: `${serviceBaseUrl}/benefitplanmapping`,
  PLAN_LIST: `${serviceBaseUrl}/benefitplan`,
  PLAN_DETAIL_LIST: `${serviceBaseUrl}/benefitplan/details`,
  PLAN_DETAIL_PAGE: (pageNumber, pageSize, offerType, sort) => {
    let url = `${serviceBaseUrl}/benefitplan/details/page?pageNumber=${pageNumber}&pageSize=${pageSize}${offerType ? `&offerType=${offerType}` : ""}`;
    if (sort && sort.length > 0) {
      sort.forEach((s, index) => {
        url += `&sort[${index}].field=${s.field}&sort[${index}].dir=${s.dir}`;
      });
    }
    return url;
  },
  PLAN_MAPPING_STATUS: `${serviceBaseUrl}/BenefitPlanMapping/mappingstatus`,
  PLAN_RATES_GET: (oePeriodId, planId) =>
    `${serviceBaseUrl}/benefitplan/rates?oePeriodId=${oePeriodId}&planId=${planId}`,
  PLAN_LIST_FOR_MAPPING: (offerType) =>
    `${serviceBaseUrl}/benefitplan/mapping?offerType=${offerType}`,

  SYSTEM_MENU_FILTERS: (oePeriodId) =>
    `${serviceBaseUrl}/benefitplan/systemmenu/filters?oePeriodId=${oePeriodId}`,
  // SOF-754: when clientId is supplied, eliminated/termed plans for that client
  // are excluded from the returned list.
  SYSTEM_PLAN_DETAILS: (oePeriodId, clientId) =>
    `${serviceBaseUrl}/benefitplan/systemmenu/plandetails?oePeriodId=${oePeriodId}` +
    (clientId ? `&clientId=${encodeURIComponent(clientId)}` : ""),
  SYSTEM_MENU_DOWNLAOD: (
    oePeriodId,
    offerTypeCode,
    benefitGroup,
    rateGroup,
    isExcel,
    bundleIndex,
  ) =>
    `${serviceBaseUrl}/benefitplan/systemmenu?oePeriodId=${oePeriodId}&offerTypeCode=${offerTypeCode}&benefitGroup=${benefitGroup}&rateGroup=${rateGroup}&isExcel=${isExcel}&bundleIndex=${bundleIndex}`,
  USER_GUIDE_DOWNLOAD: `${serviceBaseUrl}/userguide`,
  SYSTEM_MENU_DOWNLOAD_FROM_PLANS: (
    oePeriodId,
    offerTypeCode,
    benefitGroup,
    rateGroup, // always a single RG so we get a PDF
    isExcel,
    planIdsCsv,
  ) =>
    `${serviceBaseUrl}/benefitplan/systemmenu?oePeriodId=${oePeriodId}` +
    `&offerTypeCode=${encodeURIComponent(offerTypeCode)}` +
    `&benefitGroup=${encodeURIComponent(benefitGroup)}` +
    `&rateGroup=${encodeURIComponent(rateGroup)}` +
    `&isExcel=${isExcel}` +
    `&planIds=${encodeURIComponent(planIdsCsv)}`,

  RATE_GROUP_MAPPING_LIST: (offerType) =>
    `${serviceBaseUrl}/BenefitGroupMapping?offerType=${offerType}`,
  BENEFIT_GROUP_MAPPING_PAGE: (pageNumber, pageSize, offerType, sort) => {
    let url = `${serviceBaseUrl}/BenefitGroupMapping/page?pageNumber=${pageNumber}&pageSize=${pageSize}${offerType ? `&planOfferType=${offerType}` : ""}`;
    if (sort && sort.length > 0) {
      sort.forEach((s, index) => {
        url += `&sort[${index}].field=${s.field}&sort[${index}].dir=${s.dir}`;
      });
    }
    return url;
  },
  RATE_GROUP_MAPPING_POST: `${serviceBaseUrl}/BenefitGroupMapping`,
  RATE_GROUP_MAPPING_DELETE: `${serviceBaseUrl}/BenefitGroupMapping`,

  RATE_GROUP_MAP_LIST: `${serviceBaseUrl}/rategroupmapping`,
  RATE_GROUP_MAP_PAGE: (page, size, sort) => {
    let url = `${serviceBaseUrl}/rategroupmapping/page?pageNumber=${page}&pageSize=${size}`;
    if (sort && sort.length > 0) {
      sort.forEach((s, index) => {
        url += `&sort[${index}].field=${s.field}&sort[${index}].dir=${s.dir}`;
      });
    }
    return url;
  },
  RATE_GROUP_MAP_POST: `${serviceBaseUrl}/rategroupmapping`,
  RATE_GROUP_MAP_IMPORT: `${serviceBaseUrl}/rategroupmapping/bulk`,
  RATE_GROUP_MAP_PUT: `${serviceBaseUrl}/rategroupmapping`,
  RATE_GROUP_MAP_DELETE: `${serviceBaseUrl}/rategroupmapping`,

  USER_AUTHENTICATE: `${serviceBaseUrl}/Authentication/login`,
  BROKER_AUTHENTICATE: `${serviceBaseUrl}/Authentication/brokerlogin`,
  USER_LOGOUT: `${serviceBaseUrl}/Authentication/logout`,
  USER_GET: `${serviceBaseUrl}/Authentication/user/me`,
  EMPLOYEE_CENSUS_REPORT: (oePeriodId, clientId) =>
    `${serviceBaseUrl}/client/employeecensusreport?oePeriodId=${oePeriodId}&clientId=${clientId}`,
  CLIENT_STATUS_REPORT: (oePeriodId, showAllClients) =>
    `${serviceBaseUrl}/client/openenrollmentstatusreport?oePeriodId=${oePeriodId}&showAllClients=${normalizeShowAllClients(showAllClients)}`,
  CLIENT_LIST: (oePeriodId, showAllClients, isBdm) =>
    `${serviceBaseUrl}/client/openenrollmentstatus?oePeriodId=${oePeriodId}&showAllClients=${normalizeShowAllClients(showAllClients)}&isBdm=${isBdm ?? false}`,
  CLIENT_STATUS_REPORT_PAGE: (
    oePeriodId,
    showAllClients,
    page,
    size,
    sort,
    search,
    statusFilter,
    renewalFilter,
    brokerFilter,
    benefitRepFilter,
    salesRepFilter,
    carrierFilter,
    waveFilter,
  ) => {
    let url = `${serviceBaseUrl}/client/openenrollmentstatusreport/page?oePeriodId=${oePeriodId}&showAllClients=${showAllClients}&pageNumber=${page}&pageSize=${size}`;
    // Broker/carrier names and search terms carry &, #, commas and spaces; an
    // unencoded value truncates the query string at the first & and silently
    // drops everything after it (sort, remaining filters).
    if (search) url += `&search=${encodeURIComponent(search)}`;
    if (sort && sort.length > 0) {
      sort.forEach((s, index) => {
        url += `&sort[${index}].field=${encodeURIComponent(
          s.field,
        )}&sort[${index}].dir=${encodeURIComponent(s.dir)}`;
      });
    }
    if (statusFilter) url += `&statusFilter=${encodeURIComponent(statusFilter)}`;
    if (renewalFilter) url += `&renewalFilter=${encodeURIComponent(renewalFilter)}`;
    if (brokerFilter) url += `&brokerFilter=${encodeURIComponent(brokerFilter)}`;
    if (benefitRepFilter)
      url += `&benefitRepFilter=${encodeURIComponent(benefitRepFilter)}`;
    if (salesRepFilter) url += `&salesRepFilter=${encodeURIComponent(salesRepFilter)}`;
    if (carrierFilter) url += `&carrierFilter=${encodeURIComponent(carrierFilter)}`;
    if (waveFilter) url += `&waveFilter=${encodeURIComponent(waveFilter)}`;
    return url;
  },
  CLIENT_STATUS_REPORT_PARENT_PAGE: (
    oePeriodId,
    showAllClients,
    page,
    size,
    sort,
    search,
    statusFilter,
    groupStatusFilter,
  ) => {
    let url = `${serviceBaseUrl}/client/openenrollmentstatusreport/parentpage?oePeriodId=${encodeURIComponent(
      oePeriodId,
    )}&showAllClients=${encodeURIComponent(
      showAllClients,
    )}&pageNumber=${page}&pageSize=${size}`;
    // Company names carry &, #, commas and spaces; an unencoded search term
    // truncates the query string at the first & and silently drops the sort.
    if (search) url += `&search=${encodeURIComponent(search)}`;
    if (sort && sort.length > 0) {
      sort.forEach((s, index) => {
        url += `&sort[${index}].field=${encodeURIComponent(
          s.field,
        )}&sort[${index}].dir=${encodeURIComponent(s.dir)}`;
      });
    }
    if (statusFilter) url += `&statusFilter=${encodeURIComponent(statusFilter)}`;
    if (groupStatusFilter)
      url += `&groupStatusFilter=${encodeURIComponent(groupStatusFilter)}`;
    return url;
  },
  CLIENT_DETAILS: (oePeriodId, clientId) =>
    `${serviceBaseUrl}/client/openenrollmentstatusreport/details?oePeriodId=${oePeriodId}&clientId=${clientId}`,
  GET_CLIENT_BROKER: (clientId) =>
    `${serviceBaseUrl}/client/broker?clientId=${clientId}`,
  GET_CLIENT_SUBMISSION_RECORD: (clientId) =>
    `${serviceBaseUrl}/client/submissionrecord?clientId=${clientId}`,
  GET_CLIENT_BENEFIT_REP: (clientId) =>
    `${serviceBaseUrl}/client/benefitrep?clientId=${clientId}`,
  GET_CLIENT_SALES_REP: (clientId) =>
    `${serviceBaseUrl}/client/salesrep?clientId=${clientId}`,
  CLIENT_ACTIVE_OE: `${serviceBaseUrl}/client/openenrollment/active`,
  CLIENT_UPDATE_OESUMMARY_STATAS: `${serviceBaseUrl}/client/openenrollmentstatus`,
  CLIENT_CREATE_MODEL: `${serviceBaseUrl}/ClientRateModel/Create`,
  CLIENT_GET_STARTED: `${serviceBaseUrl}/ClientRateModel/GetStarted`,
  CLIENT_MODEL_ADD_PLAN: `${serviceBaseUrl}/ClientRateModel/addplan`,
  CLIENT_MODEL_SET_MAX_CONTRIBUTION: `${serviceBaseUrl}/ClientRateModel/Updatemaxcontribution`,
  CLIENT_MODEL_COPY_CONTRIBUTION: `${serviceBaseUrl}/ClientRateModel/copycontribution`,
  CLIENT_MODEL_DISCLOSURE_ACCEPT: `${serviceBaseUrl}/ClientRateModel/acceptdisclosure`,
  CLIENT_MODEL_DISCLOSURE_STATUS: (oePeriodId, clientId) =>
    `${serviceBaseUrl}/ClientRateModel/disclosurestatus?oePeriodId=${oePeriodId}&clientId=${clientId}`,

  CLIENT_MODEL_DISCLOSURE_DOWNLOAD: (oePeriodId, clientId, versionid) =>
    `${serviceBaseUrl}/ClientRateModel/downloaddisclosure?oePeriod=${oePeriodId}&clientId=${clientId}&versionId=${versionid}`,
  CLIENT_MODEL_SUMIT_RATE: (oePeriodId, clientId, versionid) =>
    `${serviceBaseUrl}/ClientRateModel/Submitrate?oePeriod=${oePeriodId}&clientId=${clientId}&versionId=${versionid}`,
  CLIENT_MODEL_UNLOCK_RATE: (oePeriodId, clientId, versionid) =>
    `${serviceBaseUrl}/ClientRateModel/unlockrate?oePeriod=${oePeriodId}&clientId=${clientId}&versionId=${versionid}`,
  CLIENT_MODEL_OVERRIDE_STATUS: `${serviceBaseUrl}/ClientRateModel/overridestatus`,
  CLIENT_MODEL_PUBLISH_RATE: (oePeriodId, clientId, versionid, isRetry) =>
    `${serviceBaseUrl}/ClientRateModel/publishrate?oePeriod=${oePeriodId}&clientId=${clientId}&versionId=${versionid}&isRetry=${isRetry}`,
  CLIENT_MODEL_DELETE_PLAN: `${serviceBaseUrl}/ClientRateModel/deleteplan`,
  CLIENT_MODEL_VERSIONS: (oePeriodId, clientId) =>
    `${serviceBaseUrl}/ClientRateModel/modelversions?oePeriod=${oePeriodId}&clientId=${clientId}`,
  CLIENT_MODEL_SUMMARY_GET: (oePeriodId, clientId, versionid, comparisonVersionId) =>
    `${serviceBaseUrl}/ClientRateModel/summary?oePeriod=${oePeriodId}&clientId=${clientId}&versionId=${versionid}` +
    (comparisonVersionId
      ? `&comparisonVersionId=${encodeURIComponent(comparisonVersionId)}`
      : ""),
  CLIENT_MODEL_AVAILABLE_PLANS: (oePeriodId, clientId, versionid, groupId) =>
    `${serviceBaseUrl}/ClientRateModel/availableplans?oePeriod=${oePeriodId}&clientId=${clientId}&versionId=${versionid}&groupId=${groupId}`,
  CLIENT_MODEL_GET: (oePeriodId, clientId, versionid) =>
    `${serviceBaseUrl}/ClientRateModel?oePeriod=${oePeriodId}&clientId=${clientId}&versionId=${versionid}`,

  CLIENT_PLANS_GET: (oePeriodId, clientId, versionid) =>
    `${serviceBaseUrl}/ClientRateModel/getclientrates?oePeriod=${oePeriodId}&clientId=${clientId}`,

  CLIENT_HSA_MATCH: (oePeriodId, clientId, versionid) =>
    `${serviceBaseUrl}/Client/clienthsamatch?oePeriodId=${oePeriodId}&clientId=${clientId}`,

  CLIENT_DCA_MATCH: (oePeriodId, clientId, versionid) =>
    `${serviceBaseUrl}/Client/clientdca?oePeriodId=${oePeriodId}&clientId=${clientId}`,

  CLIENT_FSA_GET: (oePeriodId, clientId) =>
    `${serviceBaseUrl}/Client/clientfsa?oePeriodId=${oePeriodId}&clientId=${clientId}`,
  CLIENT_FSA_UPSERT: `${serviceBaseUrl}/Client/clientfsa`,

  FLEX_CONTRIBUTION_LIMITS_GET: (oePeriodId) =>
    `${serviceBaseUrl}/FlexContributionLimit?oePeriodId=${oePeriodId}`,
  FLEX_CONTRIBUTION_LIMITS_POST: `${serviceBaseUrl}/FlexContributionLimit`,

  CLIENT_RATE_MODEL_MEDICAL_CARRIERS_GET: (oePeriodId, clientId, versionId) =>
    `${serviceBaseUrl}/ClientRateModel/medicalcarriers?oePeriodId=${oePeriodId}&clientId=${encodeURIComponent(
      clientId ?? ""
    )}&versionId=${versionId}`,

  CLIENT_RATE_MODEL_SUBMIT_CARRIER_RULE_GET: (oePeriodId, clientId, versionId) =>
    `${serviceBaseUrl}/ClientRateModel/submitcarrierrule?oePeriodId=${oePeriodId}&clientId=${encodeURIComponent(
      clientId ?? ""
    )}&versionId=${versionId}`,

  FEATURE_ACCESS_LIST_GET: (oePeriodId, featureKey, includeInactive) =>
    `${serviceBaseUrl}/FeatureAccessControl?oePeriodId=${oePeriodId}&featureKey=${encodeURIComponent(
      featureKey ?? ""
    )}&includeInactive=${includeInactive ? "true" : "false"}`,
  FEATURE_ACCESS_KEYS_GET: `${serviceBaseUrl}/FeatureAccessControl/featurekeys`,
  FEATURE_ACCESS_ENABLED_GET: (oePeriodId, clientId) =>
    `${serviceBaseUrl}/FeatureAccessControl/enabled?oePeriodId=${oePeriodId}&clientId=${encodeURIComponent(
      clientId ?? ""
    )}`,
  // No clientId: the server scopes this to the caller's own client claims.
  FEATURE_ACCESS_ENABLED_ANY_GET: (oePeriodId) =>
    `${serviceBaseUrl}/FeatureAccessControl/enabledany?oePeriodId=${oePeriodId}`,
  FEATURE_ACCESS_CLIENTS_POST: `${serviceBaseUrl}/FeatureAccessControl/clients`,
  FEATURE_ACCESS_UPDATE_KEY_POST: `${serviceBaseUrl}/FeatureAccessControl/updatefeaturekey`,
  FEATURE_ACCESS_REMOVE_POST: `${serviceBaseUrl}/FeatureAccessControl/remove`,
  FEATURE_ACCESS_REMOVE_ALL_POST: `${serviceBaseUrl}/FeatureAccessControl/removeall`,

  PORTAL_SETTING_BLOCKED_MESSAGE: `${serviceBaseUrl}/PortalSetting/blockedmessage`,

  // Report Exclusions: the per-OE-period client list the admin dashboard
  // charts and the status tracking report leave out. Demo clients (id below
  // 1000) are excluded by a server-side rule and are not on this list.
  REPORT_EXCLUSION_LIST_GET: (oePeriodId, includeInactive) =>
    `${serviceBaseUrl}/ReportExclusion?oePeriodId=${oePeriodId}&includeInactive=${
      includeInactive ? "true" : "false"
    }`,
  REPORT_EXCLUSION_CLIENTS_POST: `${serviceBaseUrl}/ReportExclusion/clients`,
  REPORT_EXCLUSION_REMOVE_POST: `${serviceBaseUrl}/ReportExclusion/remove`,

  // Sales Admin Mapping: which BDMs a PrismHR Sales Admin user supports. The
  // list is global (no OE period).
  SALES_ADMIN_MAPPING_LIST_GET: (includeInactive) =>
    `${serviceBaseUrl}/SalesAdminMapping?includeInactive=${!!includeInactive}`,
  SALES_ADMIN_MAPPING_USERS_GET: `${serviceBaseUrl}/SalesAdminMapping/users`,
  SALES_ADMIN_MAPPING_SAVE_POST: `${serviceBaseUrl}/SalesAdminMapping`,
  SALES_ADMIN_MAPPING_REMOVE_POST: `${serviceBaseUrl}/SalesAdminMapping/remove`,
  SALES_ADMIN_MAPPING_REMOVE_ALL_POST: `${serviceBaseUrl}/SalesAdminMapping/removeall`,
  SALES_ADMIN_MAPPING_RESOLVE_USER_POST: `${serviceBaseUrl}/SalesAdminMapping/users/resolve`,

  CLIENT_MODEL_EXCEL_DOWNLOAD: (oePeriodId, clientId, versionid, clientName) =>
    `${serviceBaseUrl}/ClientRateModel/excel?oePeriod=${oePeriodId}&clientId=${clientId}&clientName=${clientName}&versionId=${versionid}`,

  CLIENT_MODEL_MAXCONTRIBS: (oePeriodId, clientId, versionid) =>
    `${serviceBaseUrl}/ClientRateModel/maxcontribs?oePeriod=${oePeriodId}&clientId=${clientId}&versionId=${versionid}`,
  CLIENT_MODEL_ERRORS_GET: (oePeriodId, clientId, versionid) =>
    `${serviceBaseUrl}/ClientRateModel/errors?oePeriod=${oePeriodId}&clientId=${clientId}&versionId=${versionid}`,
  CLIENT_MODEL_UPDATE_RATE: (oePeriodId, clientId, versionid) =>
    `${serviceBaseUrl}/ClientRateModel/update?oePeriod=${oePeriodId}&clientId=${clientId}&versionId=${versionid}`,
  CLIENT_MODEL_AUDIT_RECORD: (clientId) =>
    `${serviceBaseUrl}/ClientRateModel/auditRecords?clientId=${clientId}`,
  CLIENT_MODEL_UPDATE_SUB_CLIENTS: `${serviceBaseUrl}/ClientRateModel/updatesubclients`,

  OE_WORKFLOW_GET: (oePeriodId, workflowSetupId) =>
    `${serviceBaseUrl}/OEWorkflow/${oePeriodId}?workflowSetupId=${workflowSetupId}`,
  OE_WORKFLOW_CLIENTS_GET: (oePeriodId, workflowSetupId) =>
    `${serviceBaseUrl}/OEWorkflow/${oePeriodId}/clients?workflowSetupId=${workflowSetupId}`,
  OE_WORKFLOW_CLIENT_RATE_GROUPS_GET: (oePeriodId, workflowSetupId) =>
    `${serviceBaseUrl}/OEWorkflow/${oePeriodId}/clientrategroups?workflowSetupId=${workflowSetupId}`,
  OE_WORKFLOW_CLIENTS_POST: (oePeriodId) =>
    `${serviceBaseUrl}/OEWorkflow/${oePeriodId}/clients`,
  OE_WORKFLOW_CLIENTS_POST_BULK: (oePeriodId) =>
    `${serviceBaseUrl}/OEWorkflow/${oePeriodId}/clients/bulk`,
  OE_WORKFLOW_SETUP_LIST: (oePeriodId) =>
    `${serviceBaseUrl}/OEWorkflow/${oePeriodId}/setups`,
  OE_WORKFLOW_SETUP_CREATE: (oePeriodId) =>
    `${serviceBaseUrl}/OEWorkflow/${oePeriodId}/setup`,
  OE_WORKFLOW_START: (oePeriodId, workflowSetupId) =>
    `${serviceBaseUrl}/OEWorkflow/${oePeriodId}?workflowSetupId=${workflowSetupId}`,
  OE_WORKFLOW_CONTINUE: (oePeriodId, stepId, workflowSetupId, isSkipped) =>
    `${serviceBaseUrl}/OEWorkflow/${oePeriodId}/continue?stepId=${stepId}&workflowSetupId=${workflowSetupId}&isSkipped=${isSkipped}`,
  OE_UPDATE_RATE_GROUPS_WORKFLOW_CONTINUE: (
    oePeriodId,
    stepId,
    workflowSetupId,
  ) =>
    `${serviceBaseUrl}/OEWorkflow/${oePeriodId}/clientrategroups?stepId=${stepId}&workflowSetupId=${workflowSetupId}`,
  OE_DATA_SYNC: `${serviceBaseUrl}/datasync`,
  OE_DATA_SYNC_BULK: `${serviceBaseUrl}/datasync/bulk`,
  OE_DATA_SYNC_ERROR_LOGS: (oePeriodId, workflowId) =>
    `${serviceBaseUrl}/datasync/logs?oePeriodId=${oePeriodId}&workflowId=${workflowId}`,
  OE_DATA_SYNC_HISTORY: (dataType, oePeriodId) =>
    `${serviceBaseUrl}/datasync?dataType=${dataType}&oePeriodId=${oePeriodId}`,
  OE_WORKFLOW_DAHSBAORD_SUMMARY: (oePeriodId) =>
    `${serviceBaseUrl}/OEWorkflow/dashboard?id=${oePeriodId}`,
  OE_WORKFLOW_DAHSBAORD_EXPORT: (oePeriodId) =>
    `${serviceBaseUrl}/OEWorkflow/export/clientSummery?id=${oePeriodId}`,

  CLIENT_MASTER_LIST: `${serviceBaseUrl}/clientadmin/allclients`,
  CLIENT_ADMIN_CONTACT_LIST: (clientId) =>
    `${serviceBaseUrl}/clientadmin/contacts?clientId=${clientId}`,
  CLIENT_ADMIN_BENEFITGROUOP_LIST: (clientId) =>
    `${serviceBaseUrl}/clientadmin/benefitgroups?clientId=${clientId}`,
  CLIENT_ADMIN_BENEFITPLANS_LIST: (clientId, oePeriodId) =>
    `${serviceBaseUrl}/clientadmin/benefitplans?clientId=${clientId}&oePeriodId=${oePeriodId}`,
  CLIENT_ADMIN_BENEFITRULES_LIST: (clientId, planId) =>
    `${serviceBaseUrl}/clientadmin/benefitrules?clientId=${clientId}&planId=${planId}`,

  CLIENT_ADMIN_NOTIFICATION_HISTORY: (oePeriodId, clientId) =>
    `${serviceBaseUrl}/notification/history?oePeriodId=${oePeriodId}&clientId=${clientId}`,
  CLIENT_ADMIN_MENU_DOCUMENT: (oePeriodId, clientId) =>
    `${serviceBaseUrl}/client/menudocuments?oePeriodId=${oePeriodId}&clientId=${clientId}`,
  CLIENT_ADMIN_MENU_ALL: (oePeriodId, clientId) =>
    `${serviceBaseUrl}/client/menudocuments/all?oePeriodId=${oePeriodId}&clientId=${clientId}`,
  CLIENT_CURRENT_BENEFIT_PLANS: (clientId, offerTypeCode) =>
    `${serviceBaseUrl}/client/current-benefit-plans?clientId=${clientId}&offerTypeCode=${offerTypeCode}`,
  CLIENT_ADMIN_MENU_BASE_ALL: (oePeriodId, clientId) =>
    `${serviceBaseUrl}/clientadmin/menudocuments/all/base?oePeriodId=${oePeriodId}&clientId=${clientId}`,
  CLIENT_ADMIN_MENU_FIELD_OVERRIDES_POST: `${serviceBaseUrl}/clientadmin/menufieldoverrides`,
  CLIENT_ADMIN_MENU_FIELD_OVERRIDES: (oePeriodId, clientId) =>
    `${serviceBaseUrl}/clientadmin/menufieldoverrides?clientId=${clientId}&oePeriodId=${oePeriodId}`,
  CLIENT_ADMIN_RATE_BAND_OVERRIDES_POST: `${serviceBaseUrl}/clientadmin/ratebandoverrides`,
  CLIENT_ADMIN_RATE_BAND_OVERRIDES: (oePeriodId, clientId) =>
    `${serviceBaseUrl}/clientadmin/ratebandoverrides?clientId=${clientId}&oePeriodId=${oePeriodId}`,
  CLIENT_ADMIN_RATE_BAND_OVERRIDES_HISTORY: (
    oePeriodId,
    clientId,
    benefitGroup,
    pageNumber = 1,
    pageSize = 20
  ) => {
    let url = `${serviceBaseUrl}/clientadmin/ratebandoverrides/history?clientId=${clientId}&oePeriodId=${oePeriodId}&pageNumber=${pageNumber}&pageSize=${pageSize}`;

    if (benefitGroup) {
      url += `&benefitGroup=${encodeURIComponent(benefitGroup)}`;
    }

    return url;
  },
  CLIENT_ADMIN_EMP_MENU_DOCUMENT: (oePeriodId, clientId) =>
    `${serviceBaseUrl}/client/empmenudocuments?oePeriodId=${oePeriodId}&clientId=${clientId}`,

  CLIENT_ADMIN_MENU_COMPARE_DOWNLOAD: (
    oePeriodId,
    clientId,
    docId,
    docType,
    filteredPlans,
    offerTypeCode,
  ) =>
    `${serviceBaseUrl}/client/menucompare/download?oePeriodId=${oePeriodId}&clientId=${clientId}&docId=${docId}&docType=${docType}&filteredPlans=${filteredPlans}&offerTypeCode=${offerTypeCode}`,

  // "Aetna Renewal to Multi Carrier Plan Comparison". The API resolves the previous OE
  // period itself from the selected one, so only the selected period is sent.
  CLIENT_AETNA_COMPARE_PLANS: (oePeriodId, clientId) =>
    `${serviceBaseUrl}/client/aetnacompare/plans?oePeriodId=${oePeriodId}&clientId=${encodeURIComponent(
      clientId ?? ""
    )}`,

  // "Model Based Aetna Renewal to Multi Carrier Comparison" - the same two dropdowns,
  // sourced from every rate model built for the selected OE period rather than from
  // the client's plan assignments. Genuinely period-scoped, unlike the pair above.
  CLIENT_AETNA_COMPARE_MODEL_PLANS: (oePeriodId, clientId) =>
    `${serviceBaseUrl}/client/aetnacompare/modelplans?oePeriodId=${oePeriodId}&clientId=${encodeURIComponent(
      clientId ?? ""
    )}`,

  // Plan ids are free-text and can contain characters that need escaping, so both
  // lists are encoded. Both sides are multi-select and both preserve selection
  // order, which is the column order in the workbook. Shared by both cards: the
  // download is driven purely by plan ids, so it does not care where they came from.
  CLIENT_AETNA_COMPARE_DOWNLOAD: (
    oePeriodId,
    clientId,
    aetnaPlanIds,
    planIds,
  ) =>
    `${serviceBaseUrl}/client/aetnacompare/download?oePeriodId=${oePeriodId}&clientId=${encodeURIComponent(
      clientId ?? ""
    )}&aetnaPlans=${encodeURIComponent(
      (aetnaPlanIds ?? []).join(",")
    )}&filteredPlans=${encodeURIComponent((planIds ?? []).join(","))}`,

  // The third card's download: no plan ids, since the mapping table already
  // decides every pairing. One tab per stored mapping.
  CLIENT_AETNA_COMPARE_MAPPED_DOWNLOAD: (oePeriodId, clientId) =>
    `${serviceBaseUrl}/client/aetnacompare/mappeddownload?oePeriodId=${oePeriodId}&clientId=${encodeURIComponent(
      clientId ?? ""
    )}`,

  CLIENT_ADMIN_MENU_DOCUMENT_DOWNLOADv2: (
    oePeriodId,
    clientId,
    docId,
    docType,
    filteredPlans,
    offerTypeCode,
  ) =>
    `${serviceBaseUrl}/client/menudocuments/downloadv2?oePeriodId=${oePeriodId}&clientId=${clientId}&docId=${docId}&docType=${docType}&filteredPlans=${filteredPlans}&offerTypeCode=${offerTypeCode}`,

  CLIENT_ADMIN_MENU_DOCUMENT_DOWNLOAD_PREVYEARCOMPAREv2: (
    newOePeriodId,
    oePeriodId,
    clientId,
    docId,
    docType,
    filteredPlans,
    offerTypeCode,
  ) =>
    `${serviceBaseUrl}/client/menucompare/downloadlastyearv2?newOePeriodId=${newOePeriodId}&oePeriodId=${oePeriodId}&clientId=${clientId}&docId=${docId}&docType=${docType}&filteredPlans=${filteredPlans}&offerTypeCode=${offerTypeCode}`,

  CLIENT_ADMIN_MENU_DOCUMENT_DOWNLOAD: (
    oePeriodId,
    clientId,
    docId,
    docType,
    filteredPlans,
    offerTypeCode,
  ) =>
    `${serviceBaseUrl}/client/menudocuments/download?oePeriodId=${oePeriodId}&clientId=${clientId}&docId=${docId}&docType=${docType}&filteredPlans=${filteredPlans}&offerTypeCode=${offerTypeCode}`,
  CLIENT_ADMIN_EMP_MENU_DOCUMENT_DOWNLOAD: (
    oePeriodId,
    clientId,
    docId,
    docType,
  ) =>
    `${serviceBaseUrl}/client/empmenudocuments/download?oePeriodId=${oePeriodId}&clientId=${clientId}&docId=${docId}&docType=${docType}`,
  CLIENT_ADMIN_MAINTENANCE: () => `${serviceBaseUrl}/clientadmin/maintenance`,
  CLIENT_ADMIN_GET_LATEST_MAINTENANCE: () =>
    `${serviceBaseUrl}/clientadmin/latestmaintenance`,

  NOTIFICATION_WAVES_LIST: (oePeriodId) =>
    `${serviceBaseUrl}/notification/waves?oePeriodId=${oePeriodId}`,
  NOTIFICATION_WAVES_POST: `${serviceBaseUrl}/notification/waves`,
  NOTIFICATION_WAVES_DELETE: `${serviceBaseUrl}/notification/waves`,
  NOTIFICATION_WAVES_UPDATE_STATUS: `${serviceBaseUrl}/notification/waves/status`,
  NOTIFICATION_WAVES_RESEND: `${serviceBaseUrl}/notification/waves/resend`,
  NOTIFICATION_WAVE_CLIENTS: (oePeriodId, waveId) =>
    `${serviceBaseUrl}/notification/waveclients?oePeriodId=${oePeriodId}&waveId=${waveId}`,
  NOTIFICATION_WAVE_MAIL_DETAILS: (oePeriodId, waveId, isBroker) =>
    `${serviceBaseUrl}/notification/wavemaildetails?oePeriodId=${oePeriodId}&waveId=${waveId}&isBroker=${isBroker}`,
  NOTIFICATION_WAVE_CLIENTS_POST: `${serviceBaseUrl}/notification/waveclients`,
  NOTIFICATION_WAVE_CLIENTS_DELETE: `${serviceBaseUrl}/notification/waveclients`,
  NOTIFICATION_WAVE_ERRORS: (waveId, brokerNotifications) =>
    `${serviceBaseUrl}/notification/waves/errors?notificationWaveId=${waveId}&brokerNotifications=${brokerNotifications}`,

  NOTIFICATION_REDIRECT: `${serviceBaseUrl}/notification/redirectsetup`,

  NOTIFICATION_REMINDER: `${serviceBaseUrl}/notification/remindersetup`,

  NOTIFICATION_WAVE_AVAILABLE_CLIENTS: (oePeriodId) =>
    `${serviceBaseUrl}/notification/availableclients?oePeriodId=${oePeriodId}`,
  NOTIFICATION_WAVE_BENEFIT_GROUPS: (waveId) =>
    `${serviceBaseUrl}/notification/waves/${waveId}/benefitgroup`,

  NOTIFICATION_UPLOAD_WELCOME_LETTER: (waveId, bgLookupId) =>
    `${serviceBaseUrl}/notification/welcomeletter?waveId=${waveId}&bgLookupId=${bgLookupId}`,
  NOTIFICATION_DOWNLOAD_WELCOME_LETTER: (waveId, docId) =>
    `${serviceBaseUrl}/notification/welcomeletter?waveId=${waveId}&docId=${docId}`,

  NOTIFICATION_WAVES_ADMIN_OVERRIDE: `${serviceBaseUrl}/notification/waves/adminoverride`,
  NOTIFICATION_INDIVIDUAL_CLIENTS: (oePeriodId) =>
    `${serviceBaseUrl}/notification/individualclients?oePeriodId=${oePeriodId}`,
  NOTIFICATION_SEND_INDIVIDUAL: `${serviceBaseUrl}/notification/individual`,
  NOTIFICATION_BROKER_CLIENTS: (oePeriodId) =>
    `${serviceBaseUrl}/notification/brokerclients?oePeriodId=${oePeriodId}`,
  NOTIFICATION_SEND_BROKER: `${serviceBaseUrl}/notification/broker`,
  NOTIFICATION_WAVE_REMINDERS: (waveId) =>
    `${serviceBaseUrl}/notification/waves/${waveId}/reminders`,

  BROKER_USER_LIST: `${serviceBaseUrl}/brokeruser`,
  BROKER_USER_PAGE: (pageNumber, pageSize, sort) => {
    let url = `${serviceBaseUrl}/brokeruser/page?pageNumber=${pageNumber}&pageSize=${pageSize}`;
    if (sort && sort.length > 0) {
      sort.forEach((s, index) => {
        url += `&sort[${index}].field=${s.field}&sort[${index}].dir=${s.dir}`;
      });
    }
    return url;
  },
  BROKER_USER_POST: `${serviceBaseUrl}/brokeruser`,
  BROKER_USER_PUT: `${serviceBaseUrl}/brokeruser`,
  BROKER_USER_DELETE: `${serviceBaseUrl}/brokeruser`,
  BROKER_USER_CLIENTS: (oePeriodId) =>
    `${serviceBaseUrl}/brokeruser/clients?userId=${oePeriodId}`,

  BROKER_IMPORT_TEMPLATE: `${serviceBaseUrl}/brokeruser/import/template`,
  BROKER_IMPORT_VALIDATE: `${serviceBaseUrl}/brokeruser/import/validate`,
  BROKER_IMPORT_LIST: (take) =>
    `${serviceBaseUrl}/brokeruser/import${take ? `?take=${take}` : ""}`,
  BROKER_IMPORT_GET: (id) => `${serviceBaseUrl}/brokeruser/import/${id}`,
  BROKER_IMPORT_APPLY: (id) => `${serviceBaseUrl}/brokeruser/import/${id}/apply`,

  // Broker Comms by Carrier
  BROKER_COMMS_TEMPLATES: (audience, carrierId) =>
    `${serviceBaseUrl}/broker-comms/templates?audience=${audience}${carrierId != null ? `&carrierId=${carrierId}` : ""}`,
  BROKER_COMMS_TEMPLATES_POST: `${serviceBaseUrl}/broker-comms/templates`,
  BROKER_COMMS_WAVE_CARRIERS: (waveId) =>
    `${serviceBaseUrl}/notification/waves/${waveId}/carriers`,
  BROKER_COMMS_WAVE_CARRIER_PUT: (waveId, rowId) =>
    `${serviceBaseUrl}/notification/waves/${waveId}/carriers/${rowId}`,
  BROKER_COMMS_AUDIT: (waveId, carrierId) => {
    let url = `${serviceBaseUrl}/broker-comms/audit`;
    const params = [];
    if (waveId != null) params.push(`waveId=${waveId}`);
    if (carrierId != null) params.push(`carrierId=${carrierId}`);
    if (params.length) url += `?${params.join("&")}`;
    return url;
  },
  CARRIER_RELEASE: (carrierId) => `${serviceBaseUrl}/carrier/${carrierId}/release`,

  // "Client Aetna Plan Mappings" admin screen: one Aetna plan mapped to up to three
  // alternatives, per client, per season. Client ids are free text, so they are encoded.
  CLIENT_AETNA_MAPPING_LIST_GET: (oePeriodId, clientId) =>
    `${serviceBaseUrl}/ClientAetnaPlanMapping/list?oePeriodId=${oePeriodId}&clientId=${encodeURIComponent(
      clientId ?? ""
    )}`,

  CLIENT_AETNA_MAPPING_CLIENT_GET: (oePeriodId, clientId) =>
    `${serviceBaseUrl}/ClientAetnaPlanMapping/client?oePeriodId=${oePeriodId}&clientId=${encodeURIComponent(
      clientId ?? ""
    )}`,

  CLIENT_AETNA_MAPPING_VALIDATE_POST: `${serviceBaseUrl}/ClientAetnaPlanMapping/validate`,
  CLIENT_AETNA_MAPPING_IMPORT_POST: `${serviceBaseUrl}/ClientAetnaPlanMapping/import`,
  CLIENT_AETNA_MAPPING_COPY_POST: `${serviceBaseUrl}/ClientAetnaPlanMapping/copyfromseason`,
  CLIENT_AETNA_MAPPING_REMOVE_POST: `${serviceBaseUrl}/ClientAetnaPlanMapping/remove`,
};
